import React, { createContext, useState, useContext, useEffect } from "react";

// Create language context
const LanguageContext = createContext();
const translations = {
  en: {
    // Home Page
    home: "Home",
    services: "Request Visit",
    packages: "Offers and Packages",
    contact: "Contact Us",
    login: "Login",
    "stepper.orderStatus": "Order Status",
    "stepper.statuses.booked": "Approved",
    "stepper.statuses.onTheWay": "The technician is on the way to you",
    "stepper.statuses.technicianArrived": "The technician has arrived",
    "stepper.statuses.inProgress": "Work in Progress",
    "stepper.statuses.completed": "Work completed - please rate the service",
    "stepper.statuses.canceled": "Canceled",
    "stepper.validationMessages.required": "Please fill out this field",
    // User Menu
    orders: "Orders",
    farthestFirst: "Farthest",
    nearestFirst: "Nearest",
    sortBy: "Sort By",
    logoutMessage: "You have been successfully logged out.",
    selectRating: "How would you rate our service?",
    notifications: "Notifications",
    successRating: "Thank you! Your rating has been submitted successfully.",
    profile: "Profile",
    favorites: "Favorites",
    subscriptions: "My Subscriptions",
    address: "Address",
    logout: "Logout",
    timeRemaining: "Time Remaining",
    accountAlreadyExists: "The phone number already exists",
    // Common
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    add: "Add",
    edit: "Edit",
    delete: "Delete",
    search: "Search",
    // Add more translations as needed
    welcome: `Welcome to Houf Almanazel`,
    welcomeMessage: `Your go-to destination for comprehensive and integrated services`,
    welcomeDesc: `We offer comprehensive and integrated home maintenance services that cover all your household needs, including plumbing, electrical work, and general repairs, with high quality and affordable prices. Our professional technicians arrive at your location as quickly as possible.`,
    ourServices: "Our Services",
    ourServicesDesc: `We offer a wide range of home and professional services with the highest quality standards`,
    // Subscription Package Translations
    subscriptionPackages: "Subscription Packages",
    chooseSubscriptionPackage:
      "Choose the perfect subscription package for your needs",
    mostPopular: "Most Popular",
    subscribeNow: "Subscribe Now",
    noPackagesAvailable: "No packages available at the moment.",
    currency: "SAR",
    numberVisits: "Number of visits",
    dailyMaximum: "Daily maximum",
    subscriptionPackage: "Subscription",
    // Package Specific Translations
    basicPackage: "Basic Package",
    standardPackage: "Standard Package",
    premiumPackage: "Premium Package",
    monthlyPackage: "Monthly",
    annualPackage: "Annual",
    deleteAccount: "Are you sure you want to delete the account",
    deleteMe: "delete the account",
    editAddress: "Edit Address",
    // About Page Translations
    aboutUsTitle: "About Us",
    aboutUsSubtitle:
      "We provide comprehensive and reliable home services delivered by professional technicians",
    aboutHoufTitle: "About Houf Almanazel",
    visionMissionTitle: "Our Vision & Mission",
    valuesTitle: "Our Values",
    experienceTitle: "Our Expertise",
    onlyRafha:
      "Sorry, this service is currently available only for residents of Rafha and Hail. We will be expanding coverage to your area soon.",

    addressSign: "Address Sign",
    // Company Info
    mainDescription:
      "Request with confidence and security - all service providers are contracted and guaranteed",
    aboutUsText:
      "We are a leading company in home services and maintenance for over 15 years, proud to provide the best services with the highest standards of quality and safety",
    missionText:
      "Our mission is to provide integrated maintenance solutions that meet our customers' needs with high efficiency and competitive prices",
    valuesText:
      "We are committed to credibility, transparency, and professionalism in all our dealings, and we ensure customer satisfaction in every service we provide within our conservative Saudi community",
    experienceText:
      "Our team consists of specialists in plumbing, electricity, carpentry, and air conditioning, with each technician having extensive experience in their field.",

    guaranteeText:
      "We provide a comprehensive guarantee on all our services for a full year, with technical support service available 24 hours a day to respond to your inquiries and requests",
    // Footer translations
    companyName: "Houf Almanazel",
    footerSlogan: "We provide the best solutions for our customers",
    quickLinks: "Quick Links",
    aboutUs: "About Us",
    contactUs: "Contact Us",
    plumbingServices: "All Plumbing Services",
    electricalServices: "All Electrical Services",
    comingSoonCleaning: "Coming Soon: Home Cleaning",
    comingSoonAC: "Coming Soon: AC Maintenance",
    paymentMethods: "Available Payment Methods",
    muyassar: "Muyassar",
    mada: "Mada",
    visa: "Visa",
    mastercard: "Mastercard",
    sadad: "Sadad",
    albilad: "Bank Albilad",
    alrajhi: "Al Rajhi Bank",
    termsAndConditions: "Terms & Conditions",
    privacyPolicy: "Privacy Policy",
    copyright: "All Rights Reserved",
    companyAddress: " Kingdom of Saudi Arabia",
    update: "Update",
    subscriptionsDescription:
      "Details of your active subscription packages and individual services",

    // Loading state
    loadingSubscriptions: "Loading subscriptions...",
    // New translations for cancel order feature
    cancelOrder: "Cancel Order",
    cancelOrderTitle: "Cancel Appointment",
    appointmentTime: "Visiting time:",
    orderCancelledTitle: "Appointment Cancelled",
    goBack: "Go Back",
    confirmCancel: "Confirm Cancellation",
    close: "Close",
    cancelling: "Cancelling",

    // Refund information messages
    fullRefundMessage:
      "You are eligible for a full refund as your cancellation is more than 48 hours before the appointment.",
    partialRefundMessage:
      "You are eligible for a 50% refund as your cancellation is between 12 and 24 hours before the appointment.",
    noRefundMessage:
      "No refund is available as your cancellation is less than 12 hours before the appointment.",
    packageNoVisitDeductedMessage:
      "Since you are cancelling more than 24 hours before the appointment, no visit will be deducted from your subscription package.",
    packageVisitDeductedMessage:
      "Since you are cancelling less than 24 hours before the appointment, a visit will be deducted from your subscription package balance.",
    cancelConfirmationMessage: "Your appointment has been cancelled.",
    refundPercentageMessage: " A refund of {percentage}% will be processed.",
    noRefundAppliedMessage:
      " No refund will be applied according to our policy.",
    packageNoVisitDeductedConfirmMessage:
      " No visit has been deducted from your package balance.",
    packageVisitDeductedConfirmMessage:
      " A visit has been deducted from your package balance.",

    // Refund terms
    refundTermsTitle: "Refund Terms",
    refundTerm1:
      "The user can cancel the booked appointment at least 48 hours before the scheduled appointment and receive a full refund of the amount paid.",
    refundTerm2:
      "In case of cancellation before 12 hours and less than 24 hours from the scheduled appointment, 50% of the service value is refunded.",
    refundTerm3:
      "In case of cancellation less than 12 hours before the scheduled appointment, no amount is refunded.",
    packageTerm1:
      "If cancelled at least 24 hours before the scheduled appointment, no visit will be deducted from the subscription package balance.",
    packageTerm2:
      "If cancelled less than 24 hours before the scheduled appointment, a visit will be deducted from the subscription package balance.",

    // Empty state
    noSubscriptions: "No Current Subscriptions",
    emptySubscriptionsDescription:
      "You don't have any active subscription packages at the moment. You can browse our packages and choose the one that suits your needs.",
    browsePackages: "Browse Packages",

    // Contact Us Page Translations
    contactUsSubtitle:
      "We are happy to receive your inquiries and suggestions. We will respond to you as soon as possible.",
    contactInformation: "Contact Information",
    // Header and section titles
    addresses: "Addresses",
    addNewAddress: "Add New Address",
    bookingConfirmed: "The visit has been requested successfully.",
    // Loading state
    loadingAddresses: "Loading addresses...",

    // Address details
    building: "Building",
    floor: "Floor",

    // Empty state
    noAddresses: "No registered addresses currently",
    specialPackage: "Special Package",
    // Success/Error messages
    addressDeletedSuccess: "Address deleted successfully",
    addressDeleteError: "An error occurred while deleting the address",

    officeAddress: " Kingdom of Saudi Arabia",
    phone: "Phone",
    email: "Email",
    myAccount: "My Account",
    workingHours: "Working Hours",
    workingDays: "All days of the week: 9:00 AM - 9:00 PM",

    followUs: "Follow Us On",
    sendMessage: "Send Us a Message",
    fullName: "Full Name",
    subject: "Subject",
    message: "Message",
    chooseSubject: "Choose Subject",
    generalInquiry: "General Inquiry",
    technicalSupport: "Technical Support",
    suggestion: "Suggestion",
    complaint: "Complaint",
    other: "Other",

    profileDetails: "User details and passwords",

    // Tab buttons
    basicInfo: "Basic Information",
    password: "Password",

    // Form labels

    phoneNumber: "Phone Number",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",

    // Action buttons

    loading: "Loading...",

    // OTP modal
    verificationCode: "Verification Code",
    enterVerificationCode:
      "Please enter the verification code sent to your new phone number",
    resendCode: "Resend Code",
    whatCustomersSay:
      "We take pride in our clients' trust and their positive feedback, which motivates us to keep improving continuously.",
    otpSentNotification:
      "A verification code will be sent to the new phone number",

    // Success/Error messages
    
  loginSuccess: "Login successful!",
  authenticationFailed: "Authentication failed. Please try again.",
  serviceUnavailable: "Service is not available at this time. Please try again later or login with another method.",
  popupBlocked: "Pop-up was blocked. Please allow pop-ups for this site and try again.",
  socialLoginError: "Login is not available at this time. Please try again later or login with another method.",


    invalidPhone: "Invalid phone number",
    currentPasswordRequired: "Current password is required",
    newPasswordRequired: "New password is required",
    passwordMinLength: "Password must be at least 6 characters",
    confirmPasswordRequired: "Password confirmation is required",
    passwordsMismatch: "Passwords do not match",
    enterOtpCode: "Please enter the 4-digit verification code",
    rateLimitExceeded:
      "You have exceeded the allowed number of attempts (5 attempts per hour)",
    updateSuccess: "Information updated successfully",
    otpSent: "Verification code sent to your new phone number",
    otpResent: "Verification code resent",
    updateError: "An error occurred during the update",
    passwordUpdateError: "An error occurred while updating the password",
    verificationError: "An error occurred during verification",
    resendError: "An error occurred while resending",
    rateService: "Rate Us",
    // Form Validation Messages
    nameRequired: "Name is required",
    emailRequired: "Email is required",
    emailInvalid: "Invalid email address",
    phoneRequired: "Phone number is required",
    phoneInvalid: "Phone number must be in format 05xxxxxxxx (e.g., 0506070810)",
    subjectRequired: "Subject is required",
    messageRequired: "Message is required",
    agreeRequired: "You must agree to the terms and conditions",
    accountExistsNotVerified:
      "An account with this phone number already exists. Please verify your account.",

    // Success/Error Messages
    messageSentSuccess:
      "Your message has been sent successfully! We will contact you soon.",
    formErrorsMessage: "Please correct the errors in the form",

    // Opininos Translations
    opinions: "What do our customers say about us?",

    // Login Translations
    login_title: "Login",
    createAccount: "Create Account",
    forgotPassword: "Forgot Password?",

    rememberMe: "Remember Me",
    dontHaveAccount: "Don't have an account?",
    createOne: "Create one",
    alreadyHaveAccount: "Already have an account?",
    next: "Next",

    iHaveReadAndAgree: "I have read and agree to the",
    resetPasswordIntro: "Enter your phone number to recover your password",
    sentVerificationCode:
      "We have sent a verification code to your phone number",
    enterNewPassword: "Enter your new password",

    // Validation messages for login
    selectArea: "Please select area",
    governorate: "Governorate",
    passwordRequired: "Password is required",

    passwordsNotMatch: "Passwords do not match",
    otpRequired: "Please enter the complete verification code",

 
    registrationSuccess:
      "Registration successful, please enter verification code",
    verificationSuccess: "Verified and logged in successfully",
    passwordResetSuccess: "Password changed successfully",
    loginError: "Login failed. Please try again.",
    registrationError: "Registration failed. Please try again.",
    noNotifications: "No notifications",
    noNotificationsDescription:
      "You have no new notifications at the moment. Notifications related to your orders and subscriptions will appear here.",
    resendSuccess: "Verification code resent",

    // Map component

    addressName: "Address Name",
    city: "City",
    area: "Area",
    street: "Street",
    buildingNumber: "Building Number",
    floorNumber: "Floor Number",
    landmark: "Landmark",
    addressAdded: "Address Added Successfully",
    // Validation errors
    pleaseEnterAddressName: "Please enter an address name",
    pleaseSelectRegion: "Please select a region",
    pleaseSelectCity: "Please select a city",
    pleaseEnterStreetName: "Please enter a street name",
    pleaseSelectLocationOnMap: "Please select a location on the map",

    // Map Component Placeholders
    placeholder_addressName: "Home - Office - Company",
    placeholder_region: "Enter region",
    placeholder_area: "Enter city",
    placeholder_street: "Enter street name",
    placeholder_buildingNumber: "Enter building number",
    placeholder_floorNumber: "Enter floor number",
    placeholder_addressSign: "Enter distinctive address sign",

    orderNumber: "Order #:",
    appointmentDate: "Appointment Date:",
    department: "Department:",
    servicesCount: "Services Count:",
    technicianName: "Technician Name:",
    paymentMethod: "Payment Method:",

    creditcard: "Credit Card",
    cash: "Cash",
    notSpecified: "Not Specified",

    // Map Component Messages
    mapInfoBanner:
      "Some information is not available from the map. Please complete the missing fields manually.",
    pleaseConfirmLocationOnMap:
      "Please click on the map or use current location button to confirm your location",

    // Address Form Validation

    pleaseEnterBuildingNumber: "Please enter building number",
    pleaseEnterFloorNumber: "Please enter floor number",

    // Cart and Payment

    work_1: "Work",
    add_new_address: "Add New Address",
    no_appointment_scheduled: "No appointment scheduled",
    book_appointment: "Book Appointment",
    promo_code: "Do you have a discount code?",
    apply: "Apply",
    enter_your_code_here: "Enter your code here",
    choose_payment_method: "Choose Payment Method",
    available_payment_method: "Available Payment Method",
    services_price: "Services Price",
    discount: "Discount",
    total: "Total",
    addComment: "Add a comment (optional)",
    commentPlaceholder: "Share your experience with us...",
    confirm_payment: "Confirm Payment",
    no_services_added: "No services added to your cart",
    start_shopping: "Start Shopping",
    no_address: "No address added",
    purchaseFailed: "Purchase Failed",
    purchaseSuccess: "Successful Purchase",
    redirectCountdownPrefix: "You will be redirected in",
    trackOrderInfo: "You can track your order from the My Orders page",
    failedTransactionAlt: "failed transaction",
    successTransactionAlt: "success transaction",
    seconds: "seconds",

    currentOrders: "Current Orders",
    completedOrders: "Completed Orders",
    orderNumberPlaceholder: "Order number...",
    loadingOrders: "Loading orders...",
    noCurrentOrders: "No Current Orders",
    noCompletedOrders: "No Completed Orders",
    noCurrentOrdersDescription:
      "You don't have any orders in progress. You can browse our services and add a new order.",
    noCompletedOrdersDescription:
      "You don't have any completed orders yet. Your completed and cancelled orders will appear here.",
    browseServices: "Browse Services",
    paginationInfo: "Showing ${start} - ${end} of ${total} orders",
    active: "Active",
    expired: "Expired",
    startDate: "Start Date:",
    endDate: "End Date:",
    subscriptionAddress: "Subscription Address",
    requestEdit: "Request Edit",
    daysRemaining: "days remaining",
    packageIncludes: "What the package includes",
    year: "year",
    month: "month",
    renewSubscription: "Renew Subscription",
    requestVisit: "Request Visit",
    warning: "Warning",
    submitting: "Submitting...",
    submitRating: "Submit Rating",
    tamara: "Tamara",
    notificationDeleted: "Notification deleted successfully",
    addressWarningText:
      "You cannot change the entire address; only minor corrections such as spelling mistakes or details like the building number or floor are allowed.",

    ok: "OK",
    selectGovernorate: "Select Governorate",
    subscriptionAddressUpdated:
      "Thank you for submitting your request. Please note that the request will be reviewed by the responsible officer, and you will be contacted as soon as the review is completed.",
  },
  ar: {
    // Home Page
    home: "الرئيسية",
    services: "اطلب زيارة",
    packages: "العروض والباقات",
    contact: "تواصل معنا",
    login: "تسجيل الدخول",
    tamara: "تمارا",
    notificationDeleted: "تم حذف الإشعار بنجاح",
    // Cart and Payment
    no_address: "لا يوجد عنوان مضاف",
    work_1: "العمل",
    add_new_address: "إضافة عنوان جديد",
    no_appointment_scheduled: "لم يتم تحديد موعد",
    book_appointment: "حجز موعد",
    promo_code: "هل لديك كود خصم؟",
    apply: "تطبيق",
    logoutMessage: "تم تسجيل خروجك بنجاح.",
    submitting: "جارٍ الإرسال...",
    successRating: "شكرًا لك! تم إرسال تقييمك بنجاح.",
    submitRating: "إرسال التقييم",
    enter_your_code_here: "أدخل الرمز هنا",
    choose_payment_method: "اختر طريقة الدفع",
    available_payment_method: "طرق الدفع المتاحة",
    visa: "فيزا",
    
  loginSuccess: "تم تسجيل الدخول بنجاح!",
  authenticationFailed: "فشلت المصادقة. يرجى المحاولة مرة أخرى.",
  serviceUnavailable: "الخدمة غير متاحة في الوقت الحالي. يرجى المحاولة لاحقًا أو تسجيل الدخول بطريقة أخرى.",
  popupBlocked: "تم حظر النافذة المنبثقة. يرجى السماح بالنوافذ المنبثقة لهذا الموقع والمحاولة مرة أخرى.",
  socialLoginError: "تسجيل الدخول غير متاح في الوقت الحالي. يرجى المحاولة لاحقًا أو تسجيل الدخول بطريقة أخرى.",

    mastercard: "ماستركارد",
    services_price: "سعر الخدمات",
    discount: "الخصم",
    total: "الإجمالي",
    currency: "ريال",
    confirm_payment: "تأكيد الدفع",
    no_services_added: "لا توجد خدمات مضافة إلى سلة التسوق",
    start_shopping: "ابدأ التسوق",
    farthestFirst: "الابعد",
    nearestFirst: "الاقرب",
    sortBy: "ترتيب حسب",
    orderNumber: "رقم الطلب:",
    appointmentDate: "موعد الزيارة:",
    department: "القسم:",
    servicesCount: "عدد الخدمات:",
    technicianName: "اسم الفني:",
    paymentMethod: "طريقة الدفع:",
    "stepper.orderStatus": "حالة الطلب",
    "stepper.statuses.booked": "تمت الموافقة",
    "stepper.statuses.onTheWay": "الفني في الطريق اليك",
    "stepper.statuses.technicianArrived": "وصل الفني إلى موقع العمل",
    "stepper.statuses.inProgress": "جاري العمل",
    "stepper.statuses.completed": "تم الانتهاء برجاء تقيم الخدمة",
    "stepper.statuses.canceled": "تم الإلغاء",
    "stepper.validationMessages.required": "هذا الحقل مطلوب",

    creditcard: "بطاقة ائتمان",
    cash: "نقدًا",
    notSpecified: "غير محدد",
    // New translations for cancel order feature
    cancelOrder: "إلغاء الطلب",
    cancelOrderTitle: "إلغاء الموعد",
    orderCancelledTitle: "تم إلغاء الموعد",
    goBack: "العودة",
    confirmCancel: "تأكيد الإلغاء",
    close: "إغلاق",

    // Refund information messages
    fullRefundMessage:
      "أنت مؤهل للحصول على استرداد كامل لأن الإلغاء يتم قبل أكثر من 48 ساعة من الموعد.",
    partialRefundMessage:
      "أنت مؤهل للحصول على استرداد بنسبة 50٪ لأن الإلغاء يتم بين 12 و 24 ساعة قبل الموعد.",
    noRefundMessage:
      "لا يوجد استرداد متاح لأن الإلغاء يتم قبل أقل من 12 ساعة من الموعد.",
    packageNoVisitDeductedMessage:
      "بما أنك تقوم بالإلغاء قبل أكثر من 24 ساعة من الموعد، لن يتم خصم أي زيارة من باقة اشتراكك.",
    packageVisitDeductedMessage:
      "بما أنك تقوم بالإلغاء قبل أقل من 24 ساعة من الموعد، سيتم خصم زيارة من رصيد باقة اشتراكك.",
    cancelConfirmationMessage: "تم إلغاء موعدك.",
    refundPercentageMessage: " سيتم معالجة استرداد بنسبة {percentage}٪.",
    noRefundAppliedMessage: " لن يتم تطبيق أي استرداد وفقًا لسياستنا.",
    packageNoVisitDeductedConfirmMessage: " لم يتم خصم أي زيارة من رصيد باقتك.",
    packageVisitDeductedConfirmMessage: " تم خصم زيارة من رصيد باقتك.",
    appointmentTime: "وقت الزيارة:",

    // Refund terms
    refundTermsTitle: "شروط الاسترداد",
    refundTerm1:
      "يمكن للمستخدم إلغاء الموعد المحجوز قبل 48 ساعة على الأقل من الموعد المحدد والحصول على استرداد كامل للمبلغ المدفوع.",
    refundTerm2:
      "في حالة الإلغاء قبل 12 ساعة وأقل من 24 ساعة من الموعد المحدد، يتم استرداد 50٪ من قيمة الخدمة.",
    refundTerm3:
      "في حالة الإلغاء قبل أقل من 12 ساعة من الموعد المحدد، لا يتم استرداد أي مبلغ.",
    packageTerm1:
      "إذا تم الإلغاء قبل 24 ساعة على الأقل من الموعد المحدد، لن يتم خصم أي زيارة من رصيد باقة الاشتراك.",
    packageTerm2:
      "إذا تم الإلغاء قبل أقل من 24 ساعة من الموعد المحدد، سيتم خصم زيارة من رصيد باقة الاشتراك.",

    // User Menu
    orders: "الطلبات",
    notifications: "الإشعارات",
    profile: "الملف الشخصي",
    favorites: "المفضلة",
    subscriptions: "إدارة اشتراكاتي",

    address: "العنوان",
    logout: "تسجيل الخروج",
    addressSign: "علامة مميزة",
    subscriptionsDescription:
      "تفاصيل باقات الاشتراك والخدمات المنفردة النشطة الخاصة بك",

    // Loading state
    loadingSubscriptions: "جاري تحميل الاشتراكات...",
    deleteAccount: "هل انت متاكد من حذف الحساب",
    deleteMe: "حذف الحساب",
    // Empty state
    noSubscriptions: "لا يوجد اشتراكات حالياً",
    emptySubscriptionsDescription:
      "ليس لديك أي باقات اشتراك نشطة حالياً. يمكنك تصفح باقاتنا واختيار الباقة المناسبة لاحتياجاتك.",
    browsePackages: "تصفح الباقات",
    // Common
    save: "حفظ",
    cancel: "إلغاء",
    confirm: "تأكيد",
    add: "إضافة",
    edit: "تعديل",
    delete: "حذف",
    search: "بحث",
    // Add more translations as needed
    welcome: `مرحباً بكم في حوف المنازل`,
    welcomeMessage: `جهتك الرائدة في تقديم خدمات شاملة ومتكاملة`,
    welcomeDesc: `نقدم خدمات صيانة منزلية شاملة ومتكاملة تغطي جميع احتياجات منزلك من أعمال السباكة والكهرباء والإصلاحات العامة بجودة عالية وأسعار مناسبة، على يد فنيين محترفين يصلون إليك في أسرع وقت.`,
    ourServices: "خدماتنا",
    ourServicesDesc: `نقدم مجموعة واسعة من الخدمات المنزلية والمهنية بأعلى معايير الجودة`,
    addressAdded: "تم إضافة العنوان بنجاح",
    // Subscription Package Translations
    subscriptionPackages: "باقات الاشتراك",
    chooseSubscriptionPackage: "اختر باقة الاشتراك المثالية لاحتياجاتك",
    mostPopular: "الأكثر طلباً",
    subscribeNow: "اشترك الآن",
    noPackagesAvailable: "لا توجد باقات متاحة في الوقت الحالي.",
    addresses: "العناوين",
    addNewAddress: "اضافة عنوان جديد",

    // Loading state
    loadingAddresses: "جاري تحميل العناوين...",

    // Address details
    building: "بناية",
    floor: "طابق",

    // Empty state
    noAddresses: "لا توجد عناوين مسجلة حاليا",

    // Success/Error messages
    addressDeletedSuccess: "تم حذف العنوان بنجاح",
    addressDeleteError: "حدث خطأ أثناء حذف العنوان",

    numberVisits: "عدد الزيارات",
    dailyMaximum: "الحد الأقصى اليومي",

    stepper: {
      orderStatus: "حالة الطلب",
      statuses: {
        booked: "تمت الموافقة",
        onTheWay: "في الطريق",
        technicianArrived: "وصل الفني جاري العمل",
        completed: "تم الانتهاء",
        canceled: "تم الإلغاء",
      },
      validationMessages: {
        required: "هذا الحقل مطلوب",
      },
    },

    // Package Specific Translations
    basicPackage: "الباقة الأساسية",
    standardPackage: "الباقة المتوسطة",
    premiumPackage: "الباقة المتقدمة",
    monthlyPackage: "شهري",
    annualPackage: "سنوي",

    // About Page Translations
    aboutUsTitle: "من نحن",
    aboutUsSubtitle: "نقدم خدمات منزلية شاملة وموثوقة بأيدي فنيين محترفين",
    aboutHoufTitle: "عن حوف المنازل",
    visionMissionTitle: "رؤيتنا ومهمتنا",
    valuesTitle: "قيمنا",
    experienceTitle: "خبراتنا",
    accountAlreadyExists: "رقم الجوال موجود بالفعل",
    // Company Info
    mainDescription: "أطلب بثقة وأمان جميع مقدمى الخدمات متعاقدين ومضمونين",
    aboutUsText:
      "نحن شركة رائدة في مجال الخدمات المنزلية والصيانة منذ أكثر من 15 عامًا، نفتخر بتقديم أفضل الخدمات بأعلى معايير الجودة والأمان",
    missionText:
      "مهمتنا هي توفير حلول صيانة متكاملة تلبي احتياجات عملائنا بكفاءة عالية وأسعار منافسة",
    valuesText:
      "نلتزم بالمصداقية والشفافية والاحترافية في جميع تعاملاتنا، ونضمن رضا العملاء في كل خدمة نقدمها داخل مجتمعنا السعودي المحافظ",
    experienceText:
      "يتكون فريقنا من خبراء متخصصين في مجالات السباكة والكهرباء والنجارة والتكييف، حيث يمتلك كل فني خبرة كبيرة في مجاله",
    guaranteeText:
      "نقدم ضمان شامل على جميع خدماتنا لمدة عام كامل، مع خدمة دعم فني متاحة على مدار الساعة للرد على استفساراتكم وطلباتكم",
    editAddress: "تعديل العنوان",
    // Footer translations
    companyName: "حوف المنازل",
    footerSlogan: "نوفر أفضل الحلول لعملائنا",
    quickLinks: "روابط سريعة",
    aboutUs: "من نحن",
    contactUs: "تواصل معنا",
    plumbingServices: "جميع اعمال السباكة",
    electricalServices: "جميع اعمال الكهرباء",
    comingSoonCleaning: "قريباً التنظيف المنزلي",
    comingSoonAC: "قريباً صيانة التكييف",
    paymentMethods: "طرق الدفع المتاحة",
    muyassar: "ميسر",
    mada: "مدى",

    sadad: "سداد",
    albilad: "بنك البلاد",
    alrajhi: "مصرف الراجحي",
    termsAndConditions: "الشروط والأحكام",
    privacyPolicy: "سياسة الخصوصية",
    copyright: "جميع الحقوق محفوظة",
    companyAddress: " المملكة العربية السعودية",
governorate: "المحافظة",
selectGovernorate: "اختر المحافظة",
    contactUsSubtitle:
      "يسعدنا تلقي استفساراتك واقتراحاتك. سنقوم بالرد عليك في أقرب وقت ممكن.",
    contactInformation: "معلومات الاتصال",

    officeAddress: " المملكة العربية السعودية",
    phone: "الجوال",
    email: "البريد الإلكتروني",
    workingHours: "ساعات العمل",
    workingDays: "كل أيام الأسبوع: 9:00 ص - 9:00 م",

    followUs: "تابعنا على",
    sendMessage: "أرسل لنا رسالة",
    fullName: "الاسم الكامل",
    subject: "الموضوع",
    message: "الرسالة",
    chooseSubject: "اختر الموضوع",
    generalInquiry: "استفسار عام",
    technicalSupport: "الدعم الفني",
    suggestion: "اقتراح",
    complaint: "شكوى",
    other: "أخرى",

    // Form Validation Messages
    nameRequired: "الاسم مطلوب",
    emailRequired: "البريد الإلكتروني مطلوب",
    emailInvalid: "البريد الإلكتروني غير صالح",
    phoneRequired: "رقم الجوال مطلوب",
    phoneInvalid:"يجب أن يكون رقم الهاتف بتنسيق 05xxxxxxxx",
    subjectRequired: "الموضوع مطلوب",
    messageRequired: "الرسالة مطلوبة",
    accountExistsNotVerified: "يوجد حساب بهذا الرقم, يرجى التحقق من حسابك.",
    rateLimitExceeded:
      "تم تجاوز الحد المسموح به. يرجى المحاولة مرة أخرى بعد ساعة.",

    // Success/Error Messages
    messageSentSuccess: "تم إرسال رسالتك بنجاح! سنتواصل معك قريبًا.",
    formErrorsMessage: "يرجى تصحيح الأخطاء في النموذج",

    // Opininos Translations
    opinions: "ماذا يقول عملائنا عنا؟",

    // Login Translations
    login_title: "تسجيل الدخول",
    createAccount: "انشاء حساب",
    forgotPassword: "نسيت كلمة المرور ؟",
    verificationCode: "رمز التحقق",
    newPassword: "نسيت كلمة المرور؟",
    phoneNumber: "رقم الجوال",
    password: "كلمة المرور",
    confirmPassword: "تاكيد كلمة المرور",

    rememberMe: "تذكرني",
    dontHaveAccount: "لا تمتلك حساب؟",
    createOne: "قم بإنشاء حساب",
    alreadyHaveAccount: "لدي حساب بالفعل",
    next: "التالي",

    iHaveReadAndAgree: "لقد قرأت وأوافق على",
    resetPasswordIntro: "قم بادخال رقم جوالك لاستعادة كلمة المرور",
    sentVerificationCode: "لقد قمنا بارسال رمز التأكيد الى رقم جوالك",
    enterNewPassword: "قم بادخال كلمة المرور الجديد",
    resendCode: "إعادة ارسال الرمز",
    loading: "جاري التحميل...",

    // Validation messages for login

    passwordRequired: "كلمة المرور مطلوبة",
    passwordMinLength: "كلمة المرور يجب أن تكون 6 أحرف على الأقل",

    confirmPasswordRequired: "تأكيد كلمة المرور مطلوب",
    passwordsNotMatch: "كلمة المرور غير متطابقة",
    otpRequired: "الرجاء إدخال رمز التحقق كاملا",
    agreeRequired: "يجب عليك الموافقة على الشروط والأحكام",


    registrationSuccess: "تم التسجيل بنجاح، برجاء ادخال رمز التحقق",
    verificationSuccess: "تم التحقق وتسجيل الدخول بنجاح",
    passwordResetSuccess: "تم تغيير كلمة المرور بنجاح",
    loginError: "فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.",
    registrationError: "حدث خطأ أثناء التسجيل",
    verificationError: "رمز التحقق غير صحيح",
    resendSuccess: "تم إعادة إرسال رمز التحقق",
    resendError: "فشل في إعادة إرسال الرمز",

    addressName: "اسم العنوان",
    city: "المدينة",
    area: "المنطقة",
    street: "الشارع",
    buildingNumber: "رقم المبني",
    floorNumber: "رقم الدور",
    landmark: "علامة مميزة",

    // Validation errors
    pleaseEnterAddressName: "يرجى إدخال اسم العنوان",
    pleaseSelectRegion: "يرجى اختيار المنطقة",
    pleaseSelectCity: "يرجى اختيار المدينة",
    pleaseEnterStreetName: "يرجى إدخال اسم الشارع",
    pleaseSelectLocationOnMap: "يرجى تحديد الموقع على الخريطة",

    // Map Component Placeholders
    placeholder_addressName: "منزل - مكتب - شركة",
    placeholder_region: "المنطقة",
    placeholder_area: "المدينة",
    placeholder_street: "ادخل اسم الشارع",
    placeholder_buildingNumber: "ادخل رقم المبنى",
    placeholder_floorNumber: "ادخل رقم الدور",
    placeholder_addressSign: "أدخل علامة مميزة للعنوان",

    // Map Component Messages
    mapInfoBanner:
      "بعض المعلومات غير متوفرة من الخريطة. يرجى إكمال البيانات المفقودة يدويًا.",
    pleaseConfirmLocationOnMap:
      "يرجى النقر على الخريطة أو استخدام زر الموقع الحالي لتأكيد موقعك",

    // Address Form Validation

    pleaseEnterBuildingNumber: "يرجى إدخال رقم المبنى",
    pleaseEnterFloorNumber: "يرجى إدخال رقم الدور",
    update: "تحديث",

    selectRating: "كيف تُقيّم خدمتنا؟",
    myAccount: "حسابي",
    purchaseFailed: "فشل عميلة الشراء",
    purchaseSuccess: "عملية شراء ناجحة",
    redirectCountdownPrefix: "سوف يتم اعادة توجهيك بعد",
    trackOrderInfo: "يمكنك تتبع طلبك من صفحة طلباتي",
    failedTransactionAlt: "فشل العملية",
    successTransactionAlt: "نجاح العملية",
    whatCustomersSay:
      "نفخر بثقة عملائنا وآرائهم الإيجابية التي تحفزنا على التطوير المستمر",
    seconds: "ثواني",
    bookingConfirmed: "تم طلب الزيارة بنجاح",
    currentOrders: "طلباتي الحالية",
    completedOrders: "طلباتي المنتهية",
    orderNumberPlaceholder: "رقم الطلب...",
    loadingOrders: "جاري تحميل الطلبات...",
    noCurrentOrders: "لا توجد طلبات حالية",
    noCompletedOrders: "لا توجد طلبات منتهية",
    noCurrentOrdersDescription:
      "ليس لديك أي طلبات قيد التنفيذ حالياً. يمكنك تصفح خدماتنا وإضافة طلب جديد.",
    noCompletedOrdersDescription:
      "ليس لديك أي طلبات منتهية حالياً. ستظهر هنا طلباتك المكتملة والملغاة.",
    browseServices: "تصفح الخدمات",
    paginationInfo: "عرض ${start} - ${end} من ${total} طلب",
    noNotifications: "لا توجد إشعارات",
    noNotificationsDescription:
      "ليس لديك أي إشعارات جديدة حالياً. ستظهر هنا الإشعارات المتعلقة بطلباتك واشتراكاتك.",
    timeRemaining: "الوقت المتبقي",
    subscriptionPackage: "اشتراك",
    active: "نشط",
    expired: "منتهي",
    startDate: "تاريخ البدء:",
    endDate: "تاريخ الانتهاء:",
    subscriptionAddress: "عنوان الاشتراك",
    addComment: "أضف تعليقًا (اختياري)",
    commentPlaceholder: "شاركنا تجربتك...",
    requestEdit: "طلب تعديل",
    daysRemaining: "يوم متبقي",
    packageIncludes: "ما تشمله الباقة",
    year: "سنة",
    month: "شهر",
    renewSubscription: "تجديد الاشتراك",
    requestVisit: "طلب زيارة",
    warning: "تنبيه",
    cancelling: "الإلغاء",
    selectArea: "اختر المنطقة",
    onlyRafha:
      "عذراً، هذه الخدمة متاحة حالياً فقط لسكان مدينتي رفحاء وحائل، وسوف نقوم بتغطية منطقتكم قريباً.",

    addressWarningText:
      "لا يمكنك تغيير العنوان بالكامل، بل يُسمح فقط بتعديل الأخطاء الإملائية أو التفاصيل البسيطة مثل رقم المبنى أو الدور.",
    ok: "موافق",
    subscriptionAddressUpdated:
      "شكرًا لتقديم طلبكم. نود إعلامكم بأنه سيتم مراجعة الطلب من قبل المسؤول المختص، وسيتم التواصل معكم في أقرب وقت ممكن بعد الانتهاء من المراجعة.",

    profileDetails: "تفاصيل المستخدم وكلمات المرور",

    // Tab buttons
    basicInfo: "البيانات الاساسية",

    currentPassword: "كلمة المرور الحالية",

    // OTP modal

    enterVerificationCode:
      "الرجاء إدخال رمز التحقق المرسل إلى رقم الجوال الجديد",

    otpSentNotification: "سيتم إرسال رمز تحقق إلى رقم الجوال الجديد",

    // Success/Error messages
    specialPackage: "باقة مخصصة",
    invalidPhone: "رقم الجوال غير صالح",
    currentPasswordRequired: "كلمة المرور الحالية مطلوبة",
    newPasswordRequired: "كلمة المرور الجديدة مطلوبة",

    passwordsMismatch: "كلمات المرور غير متطابقة",
    enterOtpCode: "الرجاء إدخال رمز التحقق المكون من 4 أرقام",
    rateService: "تقيم الخدمة",
    updateSuccess: "تم تحديث المعلومات بنجاح",
    otpSent: "تم إرسال رمز التحقق إلى رقم الجوال الجديد",
    otpResent: "تم إعادة إرسال رمز التحقق",
    updateError: "حدث خطأ أثناء التحديث",
    passwordUpdateError: "حدث خطأ أثناء تحديث كلمة المرور",
  },
};
// Language Provider component
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get language from localStorage or default to Arabic
    return localStorage.getItem("language") || "ar";
  });

  const [dir, setDir] = useState(() => {
    // Set direction based on language
    return localStorage.getItem("language") === "en" ? "ltr" : "rtl";
  });

  // Update language
  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem("language", lang);

    // Update direction
    const newDir = lang === "en" ? "ltr" : "rtl";
    setDir(newDir);
    document.documentElement.dir = newDir;
    document.documentElement.lang = lang;
  };

  // Set document direction on initial load
  useEffect(() => {
    document.documentElement.dir = dir;
    document.documentElement.lang = language;
  }, [dir, language]);

  // Get translation for a key
  const t = (key) => {
    return translations[language][key] || key;
  };

  // Add validation message override
  useEffect(() => {
    const overrideValidationMessages = () => {
      // Override form validation behavior for all input elements
      const originalCheckValidity = HTMLInputElement.prototype.checkValidity;

      HTMLInputElement.prototype.checkValidity = function () {
        const isValid = originalCheckValidity.call(this);

        if (!isValid && this.validity.valueMissing) {
          // Use the current direction from context instead of computing it
          const message =
            dir === "rtl" ? "هذا الحقل مطلوب" : "Please fill out this field";
          this.setCustomValidity(message);
        }

        return isValid;
      };

      // Also handle the invalid event for cases where checkValidity isn't called explicitly
      document.addEventListener(
        "invalid",
        (e) => {
          if (
            (e.target.tagName === "INPUT" ||
              e.target.tagName === "TEXTAREA" ||
              e.target.tagName === "SELECT") &&
            e.target.validity.valueMissing
          ) {
            const message =
              dir === "rtl" ? "هذا الحقل مطلوب" : "Please fill out this field";
            e.target.setCustomValidity(message);
          }
        },
        true
      );

      // Reset custom validity when input changes
      document.addEventListener(
        "input",
        (e) => {
          if (
            e.target.tagName === "INPUT" ||
            e.target.tagName === "TEXTAREA" ||
            e.target.tagName === "SELECT"
          ) {
            e.target.setCustomValidity("");
          }
        },
        true
      );
    };

    overrideValidationMessages();
  }, [dir]); // Re-run when direction changes

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t, dir }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook to use language context
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
